<template>
    <div class="mypolicy">
        <div class="search_box">
            <div class="search">
                <img src="../../../assets/image/nsale/search.png" alt="">
                <input type="search" placeholder="投被保险人/保单号/产品名称" v-model="hName" @input="debounceFetch(false)">
            </div>
            <ul class="tab_box">
                <li v-for="(item, index) in tabList" :key="index" @click="changeTab(item, index)">
                    <span :class="tabActiveIndex == index ? 'active' : 'not_active'">{{item.text}}</span>
                    <img src="../../../assets/image/nsale/tabSelected.png" alt="" v-if="tabActiveIndex == index">
                    <p class="empty_line" v-else></p>
                </li>
            </ul>
        </div>

        <div class="content">
            <div class="premium">累计<span class="red">{{summary.totalPolicyNum}}</span>单，总保费<span class="red">{{summary.totalPolicyPremium}}</span>元</div>
            <div class="product_item" v-for="(item, index) in productList" :key="index">
                <!-- 保单 -->
                <ul v-if="item.proLarge!='健康服务'&&item.proLarge!='体检卡'">
                    <li class="title" @click.stop>
                        <span class="policy_title">{{dealNull(item.proName)}}</span>
                        <span v-if="item.subPolicysNum>=1" class="right" @click="toggleHide(item, index)">批改/期缴<span class="triangle"></span></span>
                        <span v-if="item.riskShowStatus == '1'" class="right-risk"  @click="showGuide(item.policyid, item.pno)">未上传风险告知函<img src="../../../assets/image/nsale/question.png" alt=""></span>
                        <span v-if="item.riskShowStatus == '2'" class="right-risk"  @click="showText(item)">待回收风险告知函原件<img src="../../../assets/image/nsale/question.png" alt=""></span>
                    </li>
                    <li>
                        <span class="key">投保人：</span>
                        <span class="value">{{dealNull(item.accName)}}</span>
                    </li>
                    <li>
                        <span class="key">投保时间：</span>
                        <span class="value">{{filterDate(item.issueDate)}}</span>
                    </li>
                    <li>
                        <span class="key">保单号：</span>
                        <span class="value">{{dealNull(item.pno)}}</span>
                    </li>
                    <li class="flex">
                        <p>
                            <span class="key">保费：</span>
                            <span class="value">{{dealNull(item.premium)}}元</span>
                        </p>
                        <p v-if="dealNull(item.income)!='-'">
                            <span class="income">{{item.cooperationMode == 1 ? '积分':'宣传奖励'}}：</span>
                            <span class="incom_num"><span class="money_icon">￥</span>{{dealNull(item.income)}}</span>
                        </p>
                    </li>
                    <li class="flex">

                    </li>
                </ul>
                <!-- 体检卡 -->
                <ul v-else>
                    <li class="title">
                        <span class="health_title">体检卡名称：{{dealNull(item.proName)}}</span>
                    </li>
                    <li>
                        <span class="key">体检口令：</span>
                        <span class="value">{{dealNull(item.pno)}}</span>
                    </li>
                    <li>
                        <span class="key">购买时间：</span>
                        <span class="value">{{filterDate(item.issueDate)}}</span>
                    </li>
                    <li>
                        <span class="key">手机号：</span>
                        <span class="value">{{dealNull(item.mobile)}}</span>
                    </li>
                    <li class="flex">
                        <p>
                            <span class="key">保费：</span>
                            <span class="value">{{dealNull(item.premium)}}元</span>
                        </p>
                        <p v-if="dealNull(item.income)!='-'">
                           <span class="income">{{item.cooperationMode == 1 ? '积分':'宣传奖励'}}：</span>
                            <span class="incom_num"><span class="money_icon">￥</span>{{dealNull(item.income)}}</span>
                        </p>
                    </li>
                </ul>
                <div class="bottom">
                    <div class="left">
                        <span v-if="expire == '0'" class="status">已失效</span>
                        <span class="status1" v-else-if="item.status.indexOf('-')>-1 || item.status.indexOf('/')>-1||item.status=='长期'" v-html="filterStatus(item.status)"></span>
                        <span class="status2" v-else :style="getColor(item)">{{item.appointmentMode=='2' || item.appointmentMode=='3' || item.appointmentMode=='4' ? '' : item.status}}</span>
                    </div>
                    <div class="right">
                        <div class="btn" v-if="showDownloadReceiptVoucher(item)" @click="downloadReceiptVoucher(item.policyid)">收款凭证</div>
                        <div class="btn" v-if="showElecPolicy(item)" @click="goPDF(item)">电子保单</div>
                        <div class="btn" @click="goPage(item)">查看详情</div>
                        <div class="btn" v-if="isShowGoAppointment(item)" @click="goUrl(item)">去预约</div>
                    </div>
                </div>
                <div class="bg" v-if="item.isShow"></div>
                <!-- 批改 -->
                <div v-if="item.isShow">
                    <ul v-for="(item_1, index) in item.list" :key="index+item_1.pno+item.issueDate">
                        <li class="title_inner">批改保单</li>
                        <li>
                            <span class="key">批改单号：</span>
                            <span class="value">{{dealNull(item_1.cno)}}</span>
                        </li>
                        <li>
                            <span class="key">批改时间：</span>
                            <span class="value">{{filterDate(item_1.effectiveDate)}}</span>
                        </li>
                        <li>
                            <span class="key">保费：</span>
                            <span class="value">{{dealNull(item_1.premium)}}元</span>

                        </li>
                        <li v-if="dealNull(item_1.agentCommission)!='-'">
                            <span class="key">{{item.cooperationMode == 1 ? '积分':'宣传奖励'}}：</span>
                            <span class="value">{{dealNull(item_1.agentCommission)}}元</span>
                        </li>
                    </ul>
                    <!-- 期缴 -->
                    <ul v-for="(item_2, index) in item.list1" :key="index+item_2.pno+item.issueDate">
                        <li class="title_inner">期缴保单</li>
                        <li>
                            <span class="key">保单号：</span>
                            <span class="value">{{dealNull(item_2.pno)}}</span>
                        </li>
                        <li>
                            <span class="key">截至时间：</span>
                            <span class="value">{{filterDate(item_2.expireDate)}}</span>
                        </li>
                        <li>
                            <span class="key">实际缴费时间：</span>
                            <span class="value">{{filterDate(item_2.arriveAccountDate)}}</span>
                        </li>
                        <li>
                            <span class="key">保费：</span>
                            <span class="value">{{dealNull(item_2.premium)}}元</span>
                        </li>
                        <li class="no_boder" v-if="dealNull(item_2.agentCommission)!='-'">
                            <span class="key">{{item.cooperationMode == 1 ? '积分':'宣传奖励'}}：</span>
                            <span class="value">{{dealNull(item_2.agentCommission)}}元</span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="empty" v-if="nomore">没有更多了</div>
        </div>

        <cube-popup ref="downloadPop" :visible="isShowPopup" position="center" class="download-popup">
            <downloadPolicyPopup :isShow="isShowPopup" :policyDetail="policyDetail" @close="closeDownloadPopup" />
        </cube-popup>
        <cube-popup ref="showRiskInfo" position="center" :mask-closable="true">
            <div class="risk-info">
                <p class="title">回收原件要求</p>
                <p>{{ policyDetail.riskRecoveryRequirement || '' }}</p>
                <p class="title">回收快递信息</p>
                <p>{{ policyDetail.riskExpressInfo || '' }}</p>
            </div>
        </cube-popup>
    </div>
</template>
<script>
import api from "@/utils/api";
import { debounce } from '@/utils/debounce.js';
import downloadPolicyPopup from './components/downloadElcPolicy.vue';

export default {
    components: {downloadPolicyPopup},
    data() {
        return {
            tabList: [
                {
                    text: '全部',
                    value: '3'
                },
                {
                    text: '保障中',
                    value: '2'
                },
                {
                    text: '已失效',
                    value: '0'
                }
            ],
            summary: {
                totalPolicyNum: '0',
                totalPolicyPremium: '0'
            },
            hName: '',
            pagenation: {
                pageNum: 1,
                pageSize: 10,
                pages: 0,
                total: 0
            },
            nomore: true,
            tabActiveIndex: 0,
            productList: [],
            expire: '3',
            isShowPopup: false, // 是否显示下载电子保单弹框
            policyDetail: {}, // 保单详情
        };
    },
    created() {
        this.fetchPolicyList(false);
        window.addEventListener('scroll', this.listenerFunction)
    },
    destroyed() {
        window.removeEventListener('scroll', this.listenerFunction)
    },
    methods:{
        showText(data) {
            this.policyDetail = data;
            this.$refs.showRiskInfo.show()
        },
        // 关闭获取验证码弹窗
        closeDownloadPopup(item) {
            this.isShowPopup = false;
            if(item) {
                this.goPDF(item, true);
            }
        },
        // 判断当前点击产品签约结构是否属于信美人生
        showDownloadPopup(productCode) {
            return new Promise((resolve, reject) => {
                api.isXinMeiPro(productCode).then((res)=>{
                    var result = res.data;
                    if(result.returnCode=='0000'){
                        let isXinMei = result.data === '信美人生相互保险社' || result.data === ' 信美人寿相互保险社';
                        resolve(isXinMei);
                    }
                }).catch(() => {
                })
            })
        },
        debounceFetch: debounce(function(props) {
            this.fetchPolicyList(props);
        }, 1000),
        filterStatus(status) {
            if(status.indexOf('-') > -1 || status.indexOf('/')) {
                if ((new Date().getTime()) - new Date(status) > 0) {
                    return `<span style="font-size: 14px;color: #B7B7B7">已失效</span>`;
                }
                return `到期时间：${status}`
            }
        },
        // 处理null
        dealNull(str) {
            if (!str) {
                return '-';
            }
            return str;
        },
        // 处理时间格式
        filterDate(val) {
            if(!val) return '-'
            if(val=='null'||val=='undefined'){
                return '-'
            }
            if(val.indexOf('-') < 0 && val.indexOf('/') < 0) {
                return val;
            }
            let dateArr = [];
            if (val.indexOf('-') > -1) {
                dateArr = val.split('-');
            } else if (val.indexOf('/') > -1) {
                dateArr = val.split('/');
            }
            return `${dateArr[0]}年${dateArr[1]}月${dateArr[2]}日`
        },
        // 切换Tab
        changeTab(item, index) {
            this.tabActiveIndex = index;
            this.expire = item.value;
            this.pagenation = {
                pageNum: 1,
                pageSize: 10,
                total: 0,
                pages: 0
            }
            this.fetchPolicyList(false);
        },
        clearData() {
            this.productList = []
            this.pagenation = {
                pageNum: 1,
                pageSize: 10,
                total: 0,
                pages: 0
            }
            this.nomore = true;
        },
        // 收起、展开批改期缴状态
        toggleHide(item, index) {
            item.isShow = !item.isShow;
            if (item.isShow) {
                api.getPolicyBysfid({sfid: item.proSfid, userId: this.$route.query.userId}).then((res) => {
                    let { returnCode, returnMsg, content } = res.data;
                    if (returnCode !== '0000') {
                        window.$toast(returnMsg);
                        return;
                    }
                    if (content) {
                        const arr = content.policyRel.filter(item1 => item1.cno && item1.type !== "加保")
                        const arr1 = content.policyRel.filter(item1 => !item1.cno && item1.type !== "加保")
                        console.log(arr, arr1, 200)
                        this.productList.map(item1 => {
                            if (item1.proSfid == item.proSfid) {
                                item.list = arr
                                item.list1 = arr1
                            }
                        })
                        this.$forceUpdate()
                    }
                })
            } else {
                this.$set(this.productList, index, {
                    ...item,
                    isShow: false
                })
            }
        },
        // 是否显示电子保单
        showElecPolicy(item) {
            if(item.electronicInsurance == 'N') {
                return false;
            }
            if (! item) {
                return false;
            }
            let { proLarge, proName, proCode } = item;
            proLarge = proLarge || '';
            proName = proName || '';
            proCode = proCode || '';
            return proLarge!='健康服务'&&proLarge!='体检卡' && proName.indexOf('瑞华颐悦无忧') < 0 && proCode.indexOf('DHF6HSEZJ') < 0 && proCode.indexOf('WDDY01') < 0;
        },
        // 是否显示去预约
        isShowGoAppointment(item) {
            if (!(item.proLarge=='健康服务'||item.proLarge=='体检卡')) {
                return false;
            }
            if (!item.bookingPlatformLink) {
                return false;
            }
            // appointmentMode;预约方式, 1.内部链接预约,2. 外部链接预约,3.电话预约,4.其他
            if ((item.appointmentMode == '1' && item.status=='待预约')||(item.appointmentMode == '2')) {
                return true;
            }
            return false;
        },
        // 下拉加载分页
        listenerFunction(){
            this.scrollTop =  window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;//可视区的高度
            this.clientHeight = document.documentElement.clientHeight || document.body.clientHeight;//滚动条滚动时，距离顶部的距离
            this.scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;//滚动条的总高度

            if(this.scrollTop+this.clientHeight + 30>=this.scrollHeight){
                this.timer=setTimeout(()=>{   //延迟500ms加载数据
                    if(this.pagenation.pageNum<this.pagenation.pages){
                        this.pagenation.pageNum++;
                        this.debounceFetch(true)
                    }else{
                        this.nomore=true
                    }
                }, 500)
            }
        },
        // 查询订单列表
        fetchPolicyList(flag) {
            console.log(flag, 'flag')
            if (!flag) {
                this.pagenation.pageNum = 1
                this.productList = []
                this.nomore = false
            }
            const params = {
                userId: this.$route.query.userId,
                expire: this.expire,
                pageNum: this.pagenation.pageNum,
                pageSize: this.pagenation.pageSize,
                hName: this.hName
            }
            api.getPoliciesByUserId(params).then((res) => {
                console.log(res.data);
                let { returnCode, returnMsg, content } = res.data;
                if (returnCode !== '0000') {
                    window.$toast(returnMsg);
                    return;
                }
                if (!content.detail || content.detail.length < 1) {
                    this.clearData();
                }
                if(!flag){
                    this.productList=  content.detail;
                }else{
                    this.productList=this.productList.concat( content.detail);
                }
                this.productList.forEach((item) => {
                    item.isShow = false;
                })
                this.summary = content.summary;
                let { totalPolicyNum } = content.summary;
                this.pagenation.pages = totalPolicyNum/this.pagenation.pageSize;
                this.pagenation.total = totalPolicyNum;
            })
        },
        // 处理状态颜色
        getColor(item) {
            // if(item.appointmentMode=='2' || item.appointmentMode=='3' || item.appointmentMode=='4') {
            //     return '';
            // }
            let htmlStr = '';
            switch (item.status) {
                case '已预约': htmlStr = 'color: #FF7C6D';
                    break;
                case '已退保': htmlStr = 'color: #999';
                    break;
                case '待预约': htmlStr = 'color: #FFAA4D';
                    break;
                case '线下业务': htmlStr = 'color: #5599FF';
                    break;
                case '待生效': htmlStr = 'color: #FFAA4D';
                    break;
                case '已失效': htmlStr = 'color: #B7B7B7';
                    break;
                default: htmlStr = 'color: #FF7C6D';
            }
            return htmlStr;
        },
        goPage(item) {
            let name = item.proLarge == '健康服务' ||  item.proLarge == '体检卡' ? 'physicalcarddetail' : 'mypolicydetail'
	        location.href = `${location.origin}/m/bs/${name}?electronicInsurance=${item.electronicInsurance}&cooperationMode=${item.cooperationMode}&proSfid=${item.proSfid}&proCode=${item.proCode}&type=Policy&subPolicysNum=${item.subPolicysNum}&showAddPolicy=${item.showAddPolicy}&userId=${this.$route.query.userId}`
        },
        // 去预约
        goUrl(item) {
            window.location.href = `${item.bookingPlatformLink}`;
        },
       // 是否显示纽燕宝 - 下载收款凭证
        showDownloadReceiptVoucher(item) {
          if(item.proCode && ['HTNYBQZ','HTNZBQZ'].includes(item.proCode) && item.electronicInsurance != 'N') {
            return true;
          }
          return false;
        },
        // 纽燕宝 - 下载
        downloadReceiptVoucher(policyId){
          if(!policyId){
            window.$toast('暂无保单号，请稍后');
            return
          }
          const urls = `https://image.ssish.com/ssish/tiananfb/${policyId}/${policyId}_收款凭证.pdf`
          this.$router.push({
            path: '/nsale/pdfView',
            query: { url: urls }
          });
        },
        // 查看电子保单
        async goPDF(item, isSendCode) {
            // 如果没有验证码
            if(!isSendCode) {
                // 判断签约机构是否为信美人生
                let isXinMei = await this.showDownloadPopup(item.proCode);
                // 如果是信美人生，则弹出获取验证码弹窗
                if(isXinMei) {
                    debugger
                    this.isShowPopup = true;
                    this.policyDetail = item;
                    return;
                }
            }

            // if(item.epolicyUrl&&item.epolicyUrl.indexOf('http')>-1){
            //     window.location.href=item.epolicyUrl
            // }else{
            //     window.$toast('此电子保单请前往电脑端登陆yutai365.com下载');
            // }
            const u = navigator.userAgent;
            const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
            api.policyDownload({
                pno: item.pno
            }).then(res => {
                // 假设我们有一个Blob对象
                const myBlob = new Blob([res.data], { type: 'text/plain' });
                // 创建一个FileReader实例
                const reader = new FileReader();

                // 设置FileReader的onload事件处理函数，当读取操作完成时会调用这个函数
                reader.onload = function(event) {
                    // 使用event.target.result获取转换后的字符串
                    const content = event.target.result;
                    try {
                        JSON.parse(content)
                        window.$toast('此电子保单请前往电脑端登陆yutai365.com下载');
                    } catch {
                        if (isIOS) {
                            let blob = new Blob([res.data], {
                                type: "application/pdf;charset=utf-8",
                            });
                            let url = window.URL.createObjectURL(blob);
                            let aLink = document.createElement("a");
                            aLink.style.display = "none";
                            aLink.href = url;
                            aLink.setAttribute("download", "电子保单.pdf");
                            document.body.appendChild(aLink);
                            aLink.click();
                            document.body.removeChild(aLink);
                            window.URL.revokeObjectURL(url);
                        }else if(res.data) {
                            window.open('/api_op/policy/pdfPreview/' + item.pno)
                        }
                    }
                };

                reader.readAsText(myBlob, 'UTF-8');

            })
        },
        // 风险告知函指引
        showGuide(id, no) {
            this.$router.push({
                path: '/bs/risk',
                query: { id, no }
            })
        },
    },
}
</script>
<style lang="scss" scoped>
    .mypolicy {
        font-size: 12px;
        text-align: left;
        font-family: PingFangSC-Regular, PingFang SC;
        background: #f9f9f9;
        min-width: 100vw;
        min-height: 100.5vh;
        .empty {
            width: 100%;
            text-align: center;
            height: 40px;
            line-height: 40px;
        }
        .bg {
            background: #f9f9f9;
            height: 15px;
            width: 100%;
        }
        .search_box {
            background: #fff;
            width: 100%;
            padding: 10px 18px;
            box-sizing: border-box;
            .search{
                background: #f5f5f5;
                height: 35px;
                border-radius: 7px;
                margin-bottom: 5px;
                display: flex;
                align-items: center;
                img {
                    margin: 0 5px 0 11px;
                    width: 14px;
                }
                input {
                    outline: none;
                    border: none;
                    flex: 1;
                    background: transparent;
                    height: 35px;
                    line-height: 35px;
                }
                input::-webkit-input-placeholder{
                    color:#ccc;
                    font-size: 12px;
                }
                input::-moz-placeholder{   /* Mozilla Firefox 19+ */
                    color:#ccc;
                    font-size: 12px;
                }
                input:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
                    color:#ccc;
                    font-size: 12px;
                }
                input:-ms-input-placeholder{  /* Internet Explorer 10-11 */
                    color:#ccc;
                    font-size: 12px;

                }
            }
        }
        .tab_box {
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding: 0 15px;
            font-size: 13px;
            color: #333333;
            li {
                height: 40px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: flex-end;
                padding-bottom: 2px;
                box-sizing: border-box;
                .active {
                    font-size: 15px;
                    font-weight: bold;
                    margin-bottom: 4px;
                }
                .not_active {
                    margin-bottom: 4px;
                }
                .empty_line {
                    height: 6px;
                }
                img {
                    width: 19px;
                }
            }
        }
        .content {
            padding: 11px 18.5px;
            .premium {
                width: 100%;
                height: 27px;
                line-height: 27px;
                background: #fff;
                color: #999;
                border-radius: 4px;
                padding: 0 16px;
                .red {
                    color: #FFA297;
                }
            }
            .money_icon {
                font-size: 12px;
                font-weight: bold;
                color: #333;
            }
            .product_item {
                width: 100%;
                box-sizing: border-box;
                margin-top: 15px;
                ul {
                    background: #fff;
                    border-radius: 7px;
                }
                .title_inner {
                    padding: 16px 18px 0 18px;
                    font-size: 14px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    color: #333333;
                    margin-bottom: 10px;
                }
                .title {
                    position: relative;
                    padding: 16px 18px 0 18px;
                    width: 100%;
                    display: flex;
                    margin-bottom: 10px;
                    justify-content: space-between;
                    align-items: flex-start;
                    .policy_title {
                        width: 12em;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        word-break: break-all;
                        font-size: 15px;
                        font-weight: bold;
                        line-height: 21px;
                        font-size: 15px;
                        font-weight: bold;
                        line-height: 21px;
                    }
                    .health_title {
                        width: 100%;
                        font-size: 15px;
                        font-weight: bold;
                        line-height: 21px;
                        font-size: 15px;
                        font-weight: bold;
                        line-height: 21px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                    .right {
                        font-size: 13px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #333333;
                        line-height: 21px;
                        vertical-align: bottom;
                        display: flex;
                        align-items: center;
                        padding-bottom: 12px;
                        background: #fff;
                    }
                    .right-risk {
                        position:absolute;
                        right:4px;
                        top:16px;
                        color:#FF3600;
                        font-size:12px;
                        display: flex;
                        align-items: center;
                        img {
                            width: 14px;
                            margin-left: 3px;
                            margin-top: -1px;
                        }
                    }
                    .triangle{
                        display: inline-block;
                        width: 7px;
                        height: 7px;
                        background: url('../../../assets/image/nsale/down.png') no-repeat center/7px 7px;
                        margin-left: 7px;
                    }
                    .triangle.active {
                        -webkit-transform:rotate(-180deg);
                        transform:rotate(180deg);
                        -webkit-transition:-webkit-transform 1s linear;
                        transition: transform 1s linear;
                    }
                }
                li {
                    padding: 0px 18px;
                    line-height: 16px;
                    margin-bottom: 4px;
                    font-size: 12px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #666666;
                }
                li:last-child {
                    margin: 0 18px;
                    padding: 0 0 11px 0;
                    border-bottom: 1px solid #ececec;
                }
                li.flex {
                    display: flex;
                    justify-content: space-between;
                    .incom_num {
                        font-size: 18px;
                        font-family: PingFangSC-Semibold, PingFang SC;
                        font-weight: 600;
                        color: #333333;
                    }
                }
                li.no_boder {
                    border-bottom: none;
                }
                .bottom {
                    background: #fff;
                    padding: 11px 18px 13px 18px;
                    height: 40;
                    line-height: 27px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    border-radius: 0 0 7px 7px;
                    .left {
                        color: #666;
                        font-size: 12px;
                        .status {
                            font-size: 14px;
                            color: #B7B7B7
                        }
                        .status2 {
                            font-size: 14px;
                        }
                    }
                    .btn{
                        display: inline-block;
                        width: 57px;
                        height: 27px;
                        text-align: center;
                        border: none;
                        outline: none;
                        background: #EAEAEA;
                        color: #666666;
                        border-radius: 4px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-size: 11px;
                        margin-left: 3px;
                    }
                    .btn:last-child {
                        background: #FF7C6D;
                        color: #fff;
                    }
                }
            }
            .product_item:first-child {
                margin-bottom: 12px;
            }
        }

    }
    .risk-info {
        width: 80vw;
        color: #333;
        padding: 6px 16px 22px;
        line-height: 1.5;
        word-break: break-all;
        white-space: break-spaces;
        background-color: #fff;
        .title {
            font-size: 14px;
            font-weight: bold;
            margin: 16px 0 6px;
        }
    }
</style>
<style lang="scss">
.download-popup .cube-popup-center .cube-popup-content {
    top: -50% !important;
}
</style>
